<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main menu-->
<div class="da-Content">
	<!--Left Col-->
	<!--Side Bar-->
	<div class="da-Sidebar">
		<!-- <button *ngFor="let m of lstMenuItems; let i = index" class="navButton" (click)="onNavClick(i)">{{m}}</button> -->
		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: CurrentScreen >= 0 && MenuSelect == 'Name',
				PassedButton: CurrentScreen > 0 && MenuSelect != 'Name'
			}"
			(click)="onNavClick(0)"
			[disabled]="DisableButton(0)"
		>
			Name and Address
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: CurrentScreen >= 1 && MenuSelect == 'Locations',
				PassedButton: CurrentScreen > 1 && MenuSelect != 'Locations'
			}"
			(click)="onNavClick(1)"
			[disabled]="DisableButton(1)"
		>
			Locations
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: CurrentScreen >= 2 && MenuSelect == 'Schools',
				PassedButton: CurrentScreen > 2 && MenuSelect != 'Schools'
			}"
			(click)="onNavClick(2)"
			[disabled]="DisableButton(2)"
		>
			Schools Assigned
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: CurrentScreen >= 3 && MenuSelect == 'ScanStation',
				PassedButton: CurrentScreen > 3 && MenuSelect != 'ScanStation'
			}"
			(click)="onNavClick(3)"
			[disabled]="DisableButton(3)"
		>
			ScanStation Settings
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: CurrentScreen >= 4 && MenuSelect == 'Visitor Pass',
				PassedButton: CurrentScreen > 4 && MenuSelect != 'Visitor Pass'
			}"
			(click)="onNavClick(4)"
			[disabled]="DisableButton(4)"
		>
			Visitor Pass Settings
		</button>

		<button
			[ngClass]="{
				navButton: true,
				ActiveButton: CurrentScreen >= 5 && MenuSelect == 'MS Visitor Pass',
				PassedButton: CurrentScreen > 5 && MenuSelect != 'MS Visitor Pass'
			}"
			(click)="onNavClick(5)"
			[disabled]="DisableButton(5)"
		>
			CAASS Visitors Settings
		</button>
	</div>

	<!--Right Col-->
	<!--Content-->
	<div class="da-Menu">
		<caass-siteadmin-facility-name
			*ngIf="MenuSelect == lstMenuItems[0]"
			(NextClick)="onNextClick($event)"
			[FacilityNameFromMain]="FacilityName"
			[FacilityCodeFromMain]="FacilityCode"
			[PhoneFromMain]="Phone"
			[AddressFromMain]="Address"
			[CityFromMain]="City"
			[StateFromMain]="State"
			[ZipFromMain]="Zip"
			[EditMode]="EditMode"
			[DataLoading]="DataLoading"
		>
		</caass-siteadmin-facility-name>

		<caass-siteadmin-facility-locations
			*ngIf="MenuSelect == lstMenuItems[1]"
			(NextClick)="onNextClick($event)"
			[lstLocationsFromMain]="lstLocations"
			[EditMode]="EditMode"
		>
		</caass-siteadmin-facility-locations>

		<caass-siteadmin-facility-schools
			*ngIf="MenuSelect == lstMenuItems[2]"
			(NextClick)="onNextClick($event)"
			[SchoolsFromMain]="lstSchool"
			[OriginalFromMain]="lstOriginalSchool"
			[EditMode]="EditMode"
		>
		</caass-siteadmin-facility-schools>

		<caass-siteadmin-facility-scan-station
			*ngIf="MenuSelect == lstMenuItems[3]"
			(NextClick)="onNextClick($event)"
			[ScanStationDataFromMain]="ScanStationData"
			[EditMode]="EditMode"
		>
		</caass-siteadmin-facility-scan-station>

		<caass-siteadmin-facility-visitor-pass
			*ngIf="MenuSelect == lstMenuItems[4]"
			(NextClick)="onNextClick($event)"
			[EnableOffenderSearchFromMain]="EnableOffenderSearch"
			[VerificationPassIDFromMain]="VerificationPassID"
			[FacilityIDFromMain]="FacilityID"
			[EditMode]="EditMode"
			[Saving]="Saving"
		>
		</caass-siteadmin-facility-visitor-pass>

		<caass-siteadmin-facility-ms-visitor-pass
			*ngIf="MenuSelect == lstMenuItems[5]"
			(Finished)="onFinished($event)"
			[DefaultPassIDFromMain]="MSDefaultPassID"
			[OffenderHitPassIDFromMain]="MSOffenderHitPassID"
			[VerificationPassIDFromMain]="MSVerificationPassID"
			[FacilityIDFromMain]="FacilityID"
			[EditMode]="EditMode"
			[Saving]="Saving"
		>
		</caass-siteadmin-facility-ms-visitor-pass>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="Saving == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
